<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <AdresseExecutionContratSection />
</template>

<script setup lang="ts">
  import { BasicAlert } from '@designSystem/index'
  import AdresseExecutionContratSection from './sections/adresseExecutionContrat/AdresseExecutionContratSection.vue'
</script>
